import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@classroom-ai/ui/auth/hooks';

import { agentTrpc, type LeadScope } from 'src/lib/agent-trpc';

// ----------------------------------------------------------------------

const EMPTY: LeadScope = { managedCourseIds: [], visibleClassIds: [], hasLeadAccess: false };

/**
 * The caller's Lead access in a school year (epic #566): the courses they manage (course
 * tools are editable only there) and the colleagues' classes they can open from the
 * Department page. Server-computed (`department.myScope`); ED360_STAFF get everything.
 * `loading` is true until the answer is known — treat it as "no access" (fail safe).
 */
export function useLeadScope(schoolYearId: string | null) {
  const { user } = useAuthContext();
  const enabled = !!schoolYearId && (user?.role === 'SCHOOL_STAFF' || user?.role === 'ED360_STAFF');
  const q = useQuery({
    queryKey: ['departmentScope', schoolYearId ?? null],
    enabled,
    staleTime: 60_000,
    queryFn: () => agentTrpc.department.myScope({ schoolYearId: schoolYearId! }),
  });
  return { scope: q.data ?? EMPTY, loading: enabled && q.isPending };
}
